import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
    colorComponente:{
        backgroundColor: 'white',
        color: 'black',
        alignItems: "center",
        flexFlow: "row-wrap",
        border: '1px solid  #cccccc ',
        borderRadius: '20px',                
        position: "relative",
        // width: "100%",
        overflow: "auto",
		margin: '20px 30px 0px 30px',
        padding: '0px'
    },
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: '0',
        margin: 'auto',
        boxShadow: '3px 3px #205690'
    },
    AlignTable: {
        textAlign: 'center',
    },
    gridContainer: {
        // margin: '0px 5px',
    },
    grid: {
        padding: '16px 10px',
    },
    icon: {
        padding: '10px',
    },
    TypographyTitle: {
        padding: '5px 10px',
        fontWeight: 'bold',
    },
    TypographyBody: {
        textAlign: 'left',

    },
    image: {
        width: 128,
        height: 128,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    lineaDegradadaBottom:{
        position: "relative",
        bottom: 0,
        left: 0,
        width: "100%",
        height: 4,
        background: `linear-gradient(344deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,212,255,1) 100%)`,
    },     
}))